export default class Category {
    constructor(id, title, url){
        this.id = id;
        this.url = url;
        this.title = title;
    }
}